import React from 'react';

const getKdToneColor = (kd) => {
  const value = Number(kd || 0);
  if (value >= 1.2) return '#86efac';
  if (value >= 1.0) return '#fde68a';
  return '#fda4af';
};

const ModeStatCard = ({ title, stats }) => {
  if (!stats) return null;

  return (
    <article
      style={{
        borderRadius: '12px',
        border: '1px solid rgba(126, 87, 194, 0.35)',
        background: '#14121e',
        padding: '16px',
        boxShadow: '0 0 18px rgba(126, 87, 194, 0.18)',
      }}
    >
      <h3
        style={{
          margin: '0 0 14px',
          fontSize: '12px',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: '#d8c7ff',
        }}
      >
        {title}
      </h3>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '12px',
          fontSize: '14px',
        }}
      >
        <div>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#a1a1aa' }}>Games</div>
          <div style={{ fontSize: '20px', fontWeight: 700, color: '#f4f4f5' }}>{stats.games ?? 0}</div>
        </div>
        <div>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#a1a1aa' }}>Avg K/D</div>
          <div style={{ fontSize: '20px', fontWeight: 700, color: getKdToneColor(stats.avgKD) }}>{stats.avgKD ?? '0.00'}</div>
        </div>
        <div>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#a1a1aa' }}>Avg Kills</div>
          <div style={{ color: '#f4f4f5' }}>{stats.avgK ?? '0.0'}</div>
        </div>
        <div>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#a1a1aa' }}>Avg Deaths</div>
          <div style={{ color: '#f4f4f5' }}>{stats.avgD ?? '0.0'}</div>
        </div>
        <div>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#a1a1aa' }}>Avg Assists</div>
          <div style={{ color: '#f4f4f5' }}>{stats.avgA ?? '0.0'}</div>
        </div>
        <div>
          <div style={{ fontSize: '11px', textTransform: 'uppercase', color: '#a1a1aa' }}>Avg Score</div>
          <div style={{ color: '#f4f4f5' }}>{stats.avgScore ?? 0}</div>
        </div>
      </div>
    </article>
  );
};

export default ModeStatCard;
